import { render, staticRenderFns } from "./WeblogList.vue?vue&type=template&id=653804e8&scoped=true&"
import script from "./WeblogList.vue?vue&type=script&lang=js&"
export * from "./WeblogList.vue?vue&type=script&lang=js&"
import style0 from "./WeblogList.vue?vue&type=style&index=0&id=653804e8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "653804e8",
  null
  
)

export default component.exports